import { render, staticRenderFns } from "./FrontDesk.vue?vue&type=template&id=5b6a704b&scoped=true&"
import script from "./FrontDesk.vue?vue&type=script&lang=js&"
export * from "./FrontDesk.vue?vue&type=script&lang=js&"
import style0 from "./FrontDesk.vue?vue&type=style&index=0&id=5b6a704b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6a704b",
  null
  
)

export default component.exports